<template>
    <div class="h-100">
        <v-row >
            <v-col cols="auto">
                <v-btn
                        style="padding: 0; margin: 0; min-width: 40px; height: 40px"
                        outlined
                        @click="hideDetails"
                        color="#ACB7C0"
                >
                    <span><v-icon >mdi-arrow-left</v-icon></span>
                </v-btn>
            </v-col>
            <v-col class="py-3">
                <router-link :to="{ name: 'StatisticDetails', query: { type: 0 }}" replace>
                    <span :class="{'tab_header':true, 'active':selectedTab==0}">Популярные партнеры</span>
                </router-link>
                <router-link :to="{ name: 'StatisticDetails', query: { type: 1 }}" replace>
                    <span :class="{'tab_header':true, 'active':selectedTab==1}">Активные клиенты</span>
                </router-link>
                <router-link :to="{ name: 'StatisticDetails', query: { type: 2 }}" replace>
                    <span :class="{'tab_header':true, 'active':selectedTab==2}">История активации бонусов</span>
                </router-link>

            </v-col>
            <v-col cols="auto">
                <v-select
                        v-if="selectedTab!=2"
                        v-model="lastDays"
                        hide-details
                        solo
                        :items="lastDaysItems"
                ></v-select>
            </v-col>
        </v-row>

        <v-tabs-items class="partner-tab-items" v-model="selectedTab" >
            <v-tab-item  class="h-100 ">
                <v-container class="h-100 flex-column" fluid style="overflow-y: scroll">
                    <v-row>
                        <v-col cols="4">
                            <span class="ml-5">Партнер</span>
                        </v-col>
                        <v-col>
                            <span class="ml-7">Адрес</span>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col class="text-right">
                            <span class="mr-2">Активировано бонусов</span>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <popPartnersList style="calc(100% - 50px)" :lastDays="lastDays"></popPartnersList>
                </v-container>

            </v-tab-item>
            <v-tab-item class="h-100 ">
                <v-container  class="h-100 flex-column" fluid style="overflow-y: scroll">
                    <v-row>
                        <v-col cols="4">
                            <span class="ml-5">Клиент</span>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col class="text-right">
                            <span class="mr-2">Активировано бонусов</span>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <popClientsList style="calc(100% - 50px)" :lastDays="lastDays"></popClientsList>
                </v-container>

            </v-tab-item>
            <v-tab-item class="h-100" style="overflow-y: scroll">
                <activationsList class="h-100"></activationsList>
            </v-tab-item>
        </v-tabs-items>
    </div>

</template>

<script>
    const popPartnersList = ()=> import("../components/Statistics/PopPartnersList")
    const popClientsList = ()=> import("../components/Statistics/PopClientsList")
    const activationsList = () => import("../components/Statistics/ActivationsList")
    export default {
        name: "DetailsPopular",
        components:{popPartnersList, popClientsList, activationsList},
        data(){
            return{
                lastDays:30,
                selectedTab:0,
            }
        },
        mounted(){
          this.selectedTab=this.$route.query.type
        },
        computed:{
            lastDaysItems(){
                return [
                    {value: 30, text: "Последние 30 дней"},
                    {value: 7, text: "Последние 7 дней"},
                    {value: 1, text: "Последние сутки"},
                ]
            },

        },
        methods:{
            hideDetails(){
                this.$router.push({name:'Statistic'})
            }
        },
        watch:{
            $route(value){
                if(value.query!=null){
                    this.selectedTab=value.query.type
                }else this.selectedTab=0
            }
        }
    }
</script>

<style scoped>
.tab_header{
    font-weight: 600;
    font-size: 24px;
    line-height: 40px;
    color: #6E7C8D;
    margin: 0 10px;
}

    .tab_header.active{
        color: #000000;
    }
</style>